import React from 'react';
import './AssignableEventList.css';
import EventStatus from '../status/EventStatus';
import { formatDate, formatTime } from './processUtils';

/**
 * Checkbox list of events that can be assigned to a process (AssignableEventDto[] — its rule flags
 * neverPublic/linkSignup pick the status stages).
 * selectedIds: event ids; onToggle(id). `loading` shows a hint instead of the empty text.
 */
function AssignableEventList({ events, selectedIds = [], onToggle, emptyText, loading = false }) {
  if (loading) return <p className={'assignableEventsEmpty'}>Events werden geladen …</p>;
  if (!events || events.length === 0) return <p className={'assignableEventsEmpty'}>{emptyText}</p>;

  return (
    <div className={'assignableEvents'}>
      {events.map(e => {
        const checked = selectedIds.includes(e.id);
        return (
          <label key={e.id} className={`assignableEventItem ${checked ? 'isChecked' : ''}`}>
            <input type={'checkbox'} checked={checked} onChange={() => onToggle(e.id)} />
            <span className={'assignableEventDate'}>{formatDate(e.date)}</span>
            <span className={'assignableEventMeta'}>
              {e.time && <span className={'assignableEventTime'}>{formatTime(e.time)}</span>}
              {e.locationName && <span className={'assignableEventLocation'}>{e.locationName}</span>}
            </span>
            <EventStatus statusId={e.state} event={e} single compact />
          </label>
        );
      })}
    </div>
  );
}

export default AssignableEventList;
